import React from "react";
import Cookies from "js-cookie";

import { ShowWhen } from "@/components/common";
import { InterfaceLanguage } from "@/enums";
import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@/utils/apiRequest";
import { SET_INTERFACE_LANGUAGE } from "@/constants/Query";

const LanguagesList = ({
  opened,
  close,
  selectedLang,
  languagesList,
  refetch,
  isExternalPage,
}) => {
  const { mutateAsync: changeLanguage } = useMutation({
    mutationFn: (newLang: string) =>
      apiRequest(SET_INTERFACE_LANGUAGE, "put", {
        lang: newLang,
      }),

    onSuccess: () => {
      refetch();
    },
  });

  const handleChangeLanguage = async (newLang: InterfaceLanguage) => {
    try {
      close();
      if (!isExternalPage) {
        await changeLanguage(newLang);
      }
      Cookies.set("locale", newLang);
      window.location.reload();
    } catch (error) {}
  };

  return (
    <ShowWhen condition={opened}>
      <div className="absolute left-0 top-[50px] flex w-full max-w-[71px] flex-col items-center rounded-bl-[25px] rounded-br-[25px] bg-[#f5f5f5]">
        <div className="mb-2 h-[0px] w-full max-w-[51px] border border-neutral-200" />
        <ul>
          {languagesList
            .filter((item) => item !== selectedLang && item.show)
            .map((lang, index) => {
              const Icon = lang.icon;
              return (
                <li
                  key={index}
                  onClick={() => handleChangeLanguage(lang.name)}
                  className="mb-3 cursor-pointer px-4"
                >
                  <Icon className="h-[40px] w-[40px]" />
                </li>
              );
            })}
        </ul>
      </div>
    </ShowWhen>
  );
};

export { LanguagesList };
